module.exports = __webpack_public_path__ + "static/media/sc.e6584421.svg";